module.exports = __webpack_public_path__ + "static/media/up-arrow.969ff9c4.svg";